export default __webpack_public_path__ + "static/step_img_1-9d146c418d513cd3fa42bacb29f052a0.png";